<div class="modal-content w-100 h-100 d-flex flex-column">
  <div class="section-title apm-text-red text-break">
    {{ '448616' | apmTranslate }}
  </div>
  <hr class="gray-divider-1 mb-4" />
  <div class="italic">
    {{ '448599' | apmTranslate }}
  </div>
  <div class="mb-2">
    {{ data | apmTranslate }}
  </div>
  <div class="d-flex flex-row align-items-center justify-content-end mt-4">
    <apm-button variant="secondary" (buttonClick)="closeDialog()" additionalClass="min-w-md">
      {{ '444868' | apmTranslate }}
    </apm-button>
  </div>
</div>
